export const checkRoles = (roles, rolesForComparison) => {
  const prepareRoles = roles.split(",");
  if (Array.isArray(rolesForComparison)) return rolesForComparison.some(role => prepareRoles.includes(role));
  return prepareRoles.includes(rolesForComparison);
};